import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { loadRuntimeConfig } from './config/runtimeConfig';
import { initializeAxios } from './api/axios';
import { i18nInitPromise } from './i18n';

// Config, i18n et chunk App en parallèle : initializeAxios reste avant le render.
Promise.all([loadRuntimeConfig(), i18nInitPromise, import('./App')])
  .then(([, , appModule]) => {
    initializeAxios();
    const App = appModule.default;
    const mount = document.getElementById('root');
    if (!mount) {
      console.error("❌ Élément #root introuvable dans index.html — l'application ne peut pas démarrer.");
      return;
    }
    const root = ReactDOM.createRoot(mount);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('❌ Erreur fatale au démarrage (config, i18n ou chargement App):', error);
    const mount = document.getElementById('root');
    if (mount) {
      mount.innerHTML =
        '<div style="font-family:sans-serif;padding:24px;max-width:560px;margin:40px auto;">' +
        '<h1>Démarrage impossible</h1>' +
        '<p>Vérifiez la console du navigateur (F12) pour le détail technique.</p>' +
        '<p style="color:#666;font-size:14px;">Erreur : ' +
        String(error && error.message ? error.message : error) +
        '</p></div>';
    }
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
